// extracted by mini-css-extract-plugin
export default {"thirdAd":"EarphoneThirdAd_thirdAd__4CJau","productDesc":"EarphoneThirdAd_productDesc__xrQBi","titleButton":"EarphoneThirdAd_titleButton__AJVvC"};